import type { Transition } from "@uirouter/core";
import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { llmTrackerCampaignsQueryClient } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/llm-tracker-service/llmTrackerCampaignsQueryClient";
import { hasPreviousPeriodWindowForModel } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";
import type { LLModel } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import DurationService from "app/services/DurationService";

import { CLEARED_DATA_FILTER_URL_PARAMS, COLUMN_KEYS } from "./prompts-widget/consts";
import { getPromptsSortingFromUrlParams } from "./prompts-widget/hooks/usePromptsUrlParams";

const CLEARED_FILTER_PARAMS = {
    ...CLEARED_DATA_FILTER_URL_PARAMS,
    quickFilter: undefined,
    sort: undefined,
    asc: undefined,
};

const CLEARED_SORT_PARAMS = {
    sort: undefined,
    asc: undefined,
};

export const onRedirectToPromptsReport = (): transitionHookFn => {
    return async (transition: Transition) => {
        const toParams = transition.params();
        const fromParams = transition.params("from");

        const wasCampaignChanged = fromParams?.campaignId && fromParams.campaignId !== toParams.campaignId;
        const areFiltersAlreadyCleared = Object.keys(CLEARED_FILTER_PARAMS).every((key) => toParams[key] == null);

        if (wasCampaignChanged && !areFiltersAlreadyCleared) {
            return {
                params: {
                    ...toParams,
                    ...CLEARED_FILTER_PARAMS,
                },
            };
        }

        const wasDurationChanged = fromParams?.duration !== toParams?.duration;
        const wasModelChanged = fromParams?.model !== toParams?.model;
        const sorting = getPromptsSortingFromUrlParams(toParams);
        const isSortedByPopChange = sorting.dataIndex === COLUMN_KEYS.popChange;

        if (!wasCampaignChanged && (wasDurationChanged || wasModelChanged) && isSortedByPopChange) {
            const campaign = await llmTrackerCampaignsQueryClient.getCampaignById(toParams.campaignId);
            const durationData = DurationService.getDurationData(toParams.duration);
            const campaignConfig = campaign?.configs?.[toParams.model as LLModel];
            const hasPriorWindow = hasPreviousPeriodWindowForModel(durationData.raw, campaignConfig);

            if (!hasPriorWindow) {
                return {
                    params: {
                        ...toParams,
                        ...CLEARED_SORT_PARAMS,
                    },
                };
            }
        }
        return;
    };
};
